export function clampConfidence(value: number): number {
  if (Number.isNaN(value)) return 0;
  return Math.max(0, Math.min(1, value));
}

export function confidenceLabel(confidence: number): '高' | '中' | '低' {
  if (confidence >= 0.8) return '高';
  if (confidence >= 0.5) return '中';
  return '低';
}

export function confidenceTone(confidence: number): 'good' | 'medium' | 'low' {
  if (confidence >= 0.8) return 'good';
  if (confidence >= 0.5) return 'medium';
  return 'low';
}

export function averageConfidence(values: number[]): number {
  if (values.length === 0) return 0;
  return clampConfidence(values.reduce((sum, value) => sum + value, 0) / values.length);
}
